import { IEditCategoryRestaurantPropertiesContext } from './editCategoryRestaurantPropertiesContext';

export enum EditCategoryRestaurantPropertiesActionTypes {
	REFETCH_RESTAURANT_PROPERTIES_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_SUBCATEGORIES = 'SET_SUBCATEGORIES',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchRestaurantPropertiesData {
	type: EditCategoryRestaurantPropertiesActionTypes.REFETCH_RESTAURANT_PROPERTIES_DATA;
	payload: {
		needRefetchRestaurantPropertiesData: IEditCategoryRestaurantPropertiesContext['needRefetchRestaurantPropertiesData'];
	};
}

interface ISetAllData {
	type: EditCategoryRestaurantPropertiesActionTypes.SET_ALL_DATA;
	payload: {
		categoryId: IEditCategoryRestaurantPropertiesContext['categoryId'];
		categoryName: IEditCategoryRestaurantPropertiesContext['categoryName'];
		customerName: IEditCategoryRestaurantPropertiesContext['customerName'];
		activationSchedule: IEditCategoryRestaurantPropertiesContext['activationSchedule'];
		hasSchedulePriority: IEditCategoryRestaurantPropertiesContext['hasSchedulePriority'];
		deactivationSchedule: IEditCategoryRestaurantPropertiesContext['deactivationSchedule'];
		fetchedRestaurants: IEditCategoryRestaurantPropertiesContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: EditCategoryRestaurantPropertiesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditCategoryRestaurantPropertiesContext['IDSelectedRestaurant'];
		subcategories: IEditCategoryRestaurantPropertiesContext['subcategories'];
		activationSchedule: IEditCategoryRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditCategoryRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface ISetSubcategories {
	type: EditCategoryRestaurantPropertiesActionTypes.SET_SUBCATEGORIES;
	payload: {
		subcategories: IEditCategoryRestaurantPropertiesContext['subcategories'];
		activationSchedule: IEditCategoryRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditCategoryRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface IChangeActivationSchedule {
	type: EditCategoryRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditCategoryRestaurantPropertiesContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditCategoryRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditCategoryRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface ISetDataForSubmit {
	type: EditCategoryRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditCategoryRestaurantPropertiesContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditCategoryRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditCategoryRestaurantPropertiesContext['typeOfModalWindow'];
	};
}

export type TEditCategoryRestaurantPropertiesAction =
	| IRefetchRestaurantPropertiesData
	| ISetAllData
	| ISetIDRestaurant
	| ISetSubcategories
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
